import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../components/Button';
import Input from '../components/Input';
import Card from '../components/Card';
import { useGameStore } from '../stores/gameStore';
import { gameService } from '../services/gameService';
import { useSocket } from '../context/SocketContext';

const JoinGame = () => {
	const { t } = useTranslation();
	const [gameCode, setGameCode] = useState('');
	const error = useGameStore((state) => state.error);
	const setError = useGameStore((state) => state.setError);
	const playerName = useGameStore((state) => state.playerName);
	const playerId = useGameStore((state) => state.playerId);
	const setPlayerName = useGameStore((state) => state.setPlayerName);
	const resetGame = useGameStore((state) => state.resetGame);
	const { socket, connected } = useSocket();
	const setNavigationTarget = useGameStore((state) => state.setNavigationTarget);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!gameCode.trim()) {
			setError(t('common.pleaseEnterGameCodeError'));
			return;
		}
		if (!playerName.trim()) {
			setError(t('common.pleaseEnterNameError'));
			return;
		}
		gameService.joinGame(socket, connected, { gameId: gameCode, playerName, playerId });
	};

	const goToHome = () => {
		resetGame();
		setNavigationTarget('/');
	};

	return (
		<div className='container-game flex flex-col items-center justify-center min-h-screen py-12'>
			<div className='text-center mb-8 animate-fade-in'>
				<h1 className='text-4xl font-bold text-white mb-2'>{t('joinGameScreen.title')}</h1>
				<p className='text-white opacity-90'>{t('joinGameScreen.promptMessage')}</p>
			</div>

			<Card className='w-full max-w-md animate-slide-up'>
				<form onSubmit={handleSubmit}>
					<Input
						label={t('joinGameScreen.gameCodeLabel')}
						value={gameCode}
						onChange={(e) => setGameCode(e.target.value.toUpperCase())}
						placeholder={t('joinGameScreen.gameCodePlaceholder')}
						required
						autoFocus
						maxLength={10}
						className='uppercase'
					/>
					<Input
						label={t('common.yourNameLabel')}
						value={playerName}
						onChange={(e) => setPlayerName(e.target.value.toUpperCase())}
						placeholder={t('common.enterYourNamePlaceholder')}
						required
						maxLength={15}
					/>

					{error && <div className='mb-4 p-3 bg-danger-100 text-danger-700 rounded-lg'>{error}</div>}

					<div className='flex gap-3 mt-6'>
						<Button type='button' variant='secondary' onClick={goToHome} className='flex-1'>
							{t('common.cancelButton')}
						</Button>
						<Button type='submit' variant='primary' className='flex-1'>
							{t('joinGameScreen.joinButton')}
						</Button>
					</div>
				</form>
			</Card>
		</div>
	);
};

export default JoinGame;
